import { useState, useEffect } from 'react';
import axios from 'axios';

const useFetchResults = (promoId, sorteioId) => {
    const [results, setResults] = useState([]);

    useEffect(() => {
        if (!promoId || !sorteioId) {
            return;
        }

        axios.get(`${process.env.REACT_APP_API_URL}/resultados?promo_id=${promoId}&sorteio_id=${sorteioId}`)
            .then((response) => {
                setResults(response.data.data);
            })
            .catch((err) => {
                console.error(err);
            })
    }, [promoId, sorteioId]);

    return results;
}

export default useFetchResults;